import api from "./Api";

class CompraItemService {
  GetCompraItemOData(payload) {
    return api.get("/OData/CompraItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CompraItemService();
